import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const CommentWrapper = styled.span`
  border-left: 3px solid ${globals.THEME.border};
  color: ${globals.THEME.textSecondary};
  margin: 8px 0;
  padding-left: 12px;
  display: flex;
`;
